<template>
  <span style="font-size:14px;">
    <span v-if="offLine || devInfo.offLine" style="color:#FB8C00;">
      <i class="fa fa-exclamation-circle" style="margin-right:3px;" /><span v-if="showOffLine">离线</span>
    </span>
    <span v-else>
      <span
        v-if="devSwitch || (devInfo.CUR_SID === 0 || devInfo.CUR_SID === '0')
          || (devInfo.DEV_SWITCH === 1 || devInfo.DEV_SWITCH === '1')"
        style="color:#9e9e9e;"
      >
        <i v-if="showIcon" class="fa fa-exclamation-circle" style="margin-right:3px;" />未激活
      </span>
      <span v-else-if="devInfo.CUR_SID === 2 || devInfo.CUR_SID === '2'" style="color:#67C23A;">
        <i v-if="showIcon" class="fa fa-check-circle" style="margin-right:3px;" />正常
      </span>
      <span v-else-if="devInfo.CUR_SID === 1 || devInfo.CUR_SID === '1'" style="color:#F56C6C;">
        <i v-if="showIcon" class="fa fa-exclamation-circle" style="margin-right:3px;" />异常
      </span>
      <span v-else style="color:#9e9e9e;">
        <i v-if="showIcon" class="fa fa-exclamation-circle" style="margin-right:3px;" />未激活
      </span>
    </span>
  </span>
</template>

<script>
export default {
  name: 'DeviceStateText',
  components: {},
  props: {
    devInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
    showIcon: {
      type: Boolean,
      default: false
    },
    showOffLine: {
      type: Boolean,
      default: true
    },
    offLine: {
      type: Boolean,
      default: false
    },
    devSwitch: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {

    }
  },
  computed: {},
  mounted() {},
  activated() {},
  deactivated() {},
  methods: {}
}
</script>

<style scoped>
</style>
